import React, { useEffect, useState, useRef } from "react";
import { FormControl, Grid, MenuItem, Select, Skeleton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { StockChart, PieChart } from '../../../components/charts';
import { connect } from "react-redux";
import { Loading, UserLogin } from "../../../redux/action";
import { HandlesService } from "../../../core/services/handles.service";
import { InfluencerProfileService } from "../../../core/services/influencer-profile.service";
import { LocalService, UserService } from "../../../core/services";
import { CreateCampaign as CampaignService } from "../../../core/services";
import { Methods } from "../../../core/utility";
import { Link, NavLink } from 'react-router-dom';
import YTMostViewedVideos from './yt-most-viewed-videos';
import { LineChartDropDown } from "../../../components/charts/line-chart";
import YTInfluencerProfileLeft from "./yt-influencer-profile-left";
import FollowerCard from "../../brand/profile-insight/follower-card";
import IconYouTube from "../../../components/icons/icon-youtube";
import useBodyClass from "../../../hooks/useBodyClass";
import * as gtUtil from "../../../core/utility";
import { toast } from "react-toastify";
import SocialConnectRestriction from '../../../components/popup/social-connect-restrict';
import ContentLoading from "../../../components/loader/loading";
import CityList from "../../brand/profile-insight/city-list";
import { Tab, Tabs } from "react-bootstrap";
import Positive from '../../../assets/images/positive.png';
import Negative from '../../../assets/images/negative.png';
import Neutral from '../../../assets/images/neutral.png';
import { DefaultUserProfile } from "../../../config/config";
import WordCloudComponent from "../../brand/brand-data/brandPulseWordCloud";
import { SemiCirclePie } from "./semi-circle-chart";
import HighchartsReact from "highcharts-react-official";
import Highcharts from 'highcharts';
import { DonutChart } from "../../../components/charts/donut-chart";
import Slider from "react-slick";
import mama from '../../../assets/images/mama.png'
import godrej from '../../../assets/images/godrej.png'
import VideoSection from "./yt-video-section";
import VisibilityIcon from '@mui/icons-material/Visibility';
import CommentIcon from '@mui/icons-material/Comment';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import InsightsIcon from '@mui/icons-material/Insights';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import sanitizeHtml from 'sanitize-html';
import Tooltip from "@mui/material/Tooltip";
import CommonPopUp from "../../../components/popup/common-popup";
import MaterialSymbol from "../../../components/icons/material-symbol";
import { WhatsappIcon, WhatsappShareButton } from "react-share";
import "./yt-profile-insight.scss";
// Brands' Send message / Add to list: the new flow's chat and lists (never the old inbox, lists or campaigns).
const CreatorQuickActions = React.lazy(() => import("../../../modules/brand/components/insight/CreatorQuickActions"));
const CreatorPlatformSwitch = React.lazy(() => import("../../../modules/brand/components/insight/CreatorPlatformSwitch"));

const handlesService = new HandlesService();
const inflProfileService: InfluencerProfileService = new InfluencerProfileService()
const localService: LocalService = new LocalService();
const methods = new Methods()
const userService = new UserService();


interface Props {
  UserReducer: any;
  loading: (data: any) => void;
  getSubscriptionDetail: any;
  updateUser: any;
}

interface LegendItemProps {
  color: string;
  label: string;
  value: string;
}
type Influencer = {
  name: string;
  username: string;
  image: string;
};

const LegendItem: React.FC<LegendItemProps> = ({ color, label, value }) => (
  <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', width: 150, marginBottom: 4 }}>
    <div
      style={{
        width: 30,
        height: 20,
        backgroundColor: color,
        borderRadius: 4,

      }}
    />
    <span style={{ flex: 1 }}>{label}</span>
    <span className="ms-auto">{value}</span>
  </div>
);


const YoutubeProfileInsight: React.FC<Props> = (props: Props) => {
  const myref: any = useRef(null);
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString)
  // Public share mode — when rendered on the /share-profile-insight-yt route the
  // page is viewed without a logged-in user and data is fetched via the access key.
  const shareMode = window.location.pathname.includes('share-profile-insight-yt');
  const accessKey = urlParams.get('accessKey');
  const [invalidShareLink, setInvalidShareLink] = useState(false);
  const [ytInfluencerData, setytInfluencerData] = useState<any>([]);
  const [loading, setIsLoading] = useState(false)
  const [maleGenderSplit, setMaleGenderSplit] = useState()
  const [femaleGenderSplit, setFemaleGenderSplit] = useState()
  const [genderSplit, setGenderSplit] = useState<any[]>([]);
  const [columnChartData, setColumnChartData] = useState<any[]>([]);
  const [viewStockChartData, setViewStockChartData] = useState<any[]>([]);
  const [viewSubscriberGrowthData, setViewSubscriberGrowthData] = useState<any[]>([]);
  const [minStockChartData, setMinStockChartData] = useState<any[]>([]);
  const [deviceViewStockChartData, setDeviceViewStockChartData] = useState<any[]>([]);
  const [deviceAvgViewPieChartData, setDeviceAvgViewPieChartData] = useState<any[]>([]);
  const [deviceMinStockChartData, setDeviceMinStockChartData] = useState<any[]>([]);
  const [avgDeviceMinPieChartData, setAvgDeviceMinPieChartData] = useState<any[]>([]);
  const [geoViewStockChartData, setGeoViewStockChartData] = useState<any[]>([]);
  const [geoEstMinChartData, setGeoEstMinChartData] = useState<any[]>([]);
  const [geoAvgViewPieChartData, setGeoAvgViewPieChartData] = useState<any[]>([]);
  const [geoAvgViewPerPieChartData, setGeoAvgViewPerPieChartData] = useState<any[]>([]);
  const [socialSharePieChartData, setSocialSharePieChartData] = useState<any[]>([]);
  const [influencerId] = useState(() => {
    const idString = new URLSearchParams(window.location.href).get('influencerId');
    return idString ? parseInt(idString, 10) : 0;
  });
  const [influencerList, setInfluencerList] = useState<any>(null);
  const [selectInflu, setSelectInflu] = useState<any>([]);
  const [onRequestUpdate, setOnRequestUpdate] = useState<boolean>(false);
  const [requestingUpdate, setRequestingUpdate] = useState<boolean>(false);
  const [genderArrayLabel, setGenderArrayLabel] = useState()
  const [countryName, setCountryName] = useState<any>()
  const [countryNameAvg, setCountryNameAvg] = useState<any>()
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [location, setLocation] = useState('');
  const [subscription_status, setSubscription_status] = useState<any>({
    status: null,
    plan_start_date: null,
    plan_end_date: null
  });
  const [categoriesData, setCategoriesData] = useState([]);
  const [language, setLanguages] = useState([]);
  const [connected_profile, set_connected_profile] = useState<Boolean>(false);
  const [connect, setConnect] = useState<Boolean>(false);
  const [EngagementData, setEngagementData] = useState<any>(null);
  // const [postData, setPostData] = useState<any>(null);

  const [commentsData, setCommentsData] = useState<any>(null);
  const [geo_view, set_geo_view] = useState<any>(null);
  const [similar_profiles, setSimilarProfiles] = useState<any>([]);
  const [hashtagFilter, setHashtagFilter] = useState<'organic' | 'paid'>('organic');
  const [hashtags, setHashtags] = useState<any[]>([]);
  const [allHashtags, setAllHashtags] = useState<any[]>([]);
  const [timeRangePost, setTimeRangePost] = useState('6_months');
  const [videoPostData, setVideoPostData] = useState<{ [key: string]: any[] }>({});
  const [shortPostData, setShortPostData] = useState<{ [key: string]: any[] }>({});



  // to get connected youtube account sm_id
  async function getConnectedAccountId(influencer_id: number | string) {
    try {
      const res: any = await handlesService.getGoogleConnectedAccounts(influencer_id, props.UserReducer.account_type);
      if (res?.data?.rows.length > 0) {
        const connectedAccountData = res.data.rows.filter(
          (filter: any) => filter.token_status === 'Connected' || (props.UserReducer.account_type === 'Talent Partner' && filter.token_status === 'No')
        );
        if (connectedAccountData.length > 0) {
          return connectedAccountData[0].yt_id;
        }
      }
    } catch (err: any) {
      console.error('Error fetching connected accounts:', err);
      // Handle the error as needed...
    }
    // Return a default value or handle the case when no connected account is found
    return null;
  }

  useEffect(() => {
    try {
      const fetchData = async () => {
        // Public share view: sm_id/influencer_id come from the access key.
        if (shareMode) {
          getProfileInsightYt(null);
          return;
        }
        let idToSet;
        try {
          if (urlParams.get("sm_id") == null) {
            idToSet = await getConnectedAccountId(props?.UserReducer?.influencer_id);
          } else {
            idToSet = urlParams.get("sm_id");
          }

        } catch (error) {
          console.error('Error setting Instagram ID:', error);
        }
        getProfileInsightYt(idToSet);

      };
      fetchData();
    } catch (error) {
      console.error('Error fetching connected accounts:', error);
    }
  }, [connect]);

  //Colors Array
  const getColorBasedOnIndex = (index: any) => {
    const colors = ['#f9d1d1',
      '#ffa4B6',
      '#f765a3',
      '#a155b9',
      '#165baa',
      '#0b1354', "#e2bbe6", "#FF8C00", "#32CD32", "#8A2BE2", "#FFD700", "#DC143C", "#B0C4DE", "#2E8B57", "#FF6347"];
    return colors[index % colors.length];
  }


  // Function to convert date strings to Date.UTC format
  const convertToUTC = (dateString: any) => {
    try {
      const dateParts = dateString.split('-');
      const year = parseInt(dateParts[0], 10);
      const monthIndex = parseInt(dateParts[1], 10) - 1;
      const day = parseInt(dateParts[2], 10);
      return Date.UTC(year, monthIndex, day);
    }
    catch (error) {
      console.error("Error converting date to UTC:", error);
    }
  }

  //Name convert of country
  const countryNameMapping: { [key: string]: string } = {
    "Iran, Islamic Republic of": "Iran",
    "Russian Federation": "Russia",
    "Tanzania, United Republic of": "Tanzania",
    "United Arab Emirates": "UAE",
    "United Kingdom of Great Britain and Northern Ireland": "UK",
    "United States of America": "USA"
  };


  const [dataInitialized, setDataInitialized] = useState(false);
  const getProfileInsightYt = async (youtubeID: any) => {
    setIsLoading(true)
    setDataInitialized(false);
    try {

      let response;
      let responseEngagementYt;
      let responseCommentsYt;

      if (shareMode) {
        // Verify the access key, then fetch the profile + engagement + comments
        // using the sm_id/influencer_id encoded in the token.
        const verifyRes = await inflProfileService.verifySharedProfileInsightYt({ accessKey });
        if (!(verifyRes?.data?.status === 1 && verifyRes?.data?.rows?.length > 0)) {
          setInvalidShareLink(true);
          setIsLoading(false);
          setDataInitialized(true);
          return;
        }
        const { sm_id, influencer_id } = verifyRes.data.rows[0];
        response = await inflProfileService.getSharedProfileInsightYt({
          sm_id,
          influencer_id,
          accessKey,
        });
        responseEngagementYt = await inflProfileService.getProfileEngagementYt({
          sm_id,
          influencer_id,
          filter_value: 6,
          filter_unit: 'months',
        });
        responseCommentsYt = await inflProfileService.getProfileCommentsYt({
          sm_id,
          influencer_id,
        });
      } else if (props?.UserReducer?.account_type === 'Brand' || props?.UserReducer?.account_type === 'Agency') {
        response = await inflProfileService.getBrandProfileYt({
          sm_id: youtubeID,
          user_id: props.UserReducer.user_id,
          account_id: props.UserReducer.account_id,
          brand_id: props.UserReducer.brand_id,
          influencer_id: props?.UserReducer?.account_type === 'Influencer' || props?.UserReducer?.account_type === 'Talent Partner'
            ? props?.UserReducer?.influencer_id
            : urlParams.get('influencerId') || 0
        });

        responseEngagementYt = await inflProfileService.getProfileEngagementYt({
          sm_id: youtubeID,
          influencer_id: props?.UserReducer?.account_type === 'Influencer' || props?.UserReducer?.account_type === 'Talent Partner'
            ? props?.UserReducer?.influencer_id
            : urlParams.get('influencerId') || 0,
          filter_value: 6,
          filter_unit: 'months',
        });

        responseCommentsYt = await inflProfileService.getProfileCommentsYt({
          sm_id: youtubeID,
          influencer_id: props?.UserReducer?.account_type === 'Influencer' || props?.UserReducer?.account_type === 'Talent Partner'
            ? props?.UserReducer?.influencer_id
            : urlParams.get('influencerId') || 0
        });

      } else {
        response = await inflProfileService.getInfluencerProfileYt({
          sm_id: youtubeID,
          user_id: props.UserReducer.user_id,
          account_id: props.UserReducer.account_id,
          brand_id: props.UserReducer.brand_id,
          influencer_id: props?.UserReducer?.account_type === 'Influencer' || props?.UserReducer?.account_type === 'Talent Partner'
            ? props?.UserReducer?.influencer_id
            : urlParams.get('influencerId') || 0
        });

        responseEngagementYt = await inflProfileService.getProfileEngagementYt({
          sm_id: youtubeID,
          influencer_id: props?.UserReducer?.account_type === 'Influencer' || props?.UserReducer?.account_type === 'Talent Partner'
            ? props?.UserReducer?.influencer_id
            : urlParams.get('influencerId') || 0,
          filter_value: 6,
          filter_unit: 'months',
        });

        responseCommentsYt = await inflProfileService.getProfileCommentsYt({
          sm_id: youtubeID,
          influencer_id: props?.UserReducer?.account_type === 'Influencer' || props?.UserReducer?.account_type === 'Talent Partner'
            ? props?.UserReducer?.influencer_id
            : urlParams.get('influencerId') || 0
        });
      }
      
      if (response.status === gtUtil.Constants.SUCCESS) {
        set_connected_profile(false);
        setSelectInflu(response?.data?.rows?.detail)
        setytInfluencerData(response?.data?.rows)
        setOnRequestUpdate(response?.data?.rows?.detail?.[0]?.on_request_update === true || response?.data?.rows?.detail?.[0]?.on_request_update === 'True');
        setPhone(response?.data?.rows?.email_phone[0]?.primary_phone)
        setEmail(response?.data?.rows?.email_phone[0]?.primary_email)
        setSubscription_status(response?.data?.rows?.subscription_status);
        const data = response.data.rows.location_category_language[0];
        if (data) {
          const locationString = `${data.state}, ${data.country}`;
          setLocation(locationString);
        }

        // Extract categories and filter out null values
        const categoryList: any = [
          data.category1,
          data.category2,
          data.category3,
          data.category4
        ].filter(category => category !== null);
        setCategoriesData(categoryList);
        const languageList: any = [
          data.lang1,
          data.lang2,
          data.lang3,
          data.lang4
        ].filter(language => language !== null);
        setLanguages(languageList);

        setIsLoading(false);
        //age-gender-pie-chart-data
        if (Array.isArray(response?.data?.rows?.similar_profiles) && response.data.rows.similar_profiles.length > 0) {
          setSimilarProfiles(response?.data?.rows?.similar_profiles);
        }

        if (Array.isArray(response?.data?.rows?.hashtags) && response.data.rows.hashtags.length > 0) {
          setAllHashtags(response?.data?.rows?.hashtags);
          setHashtags(response?.data?.rows?.hashtags.filter((item: any) => item.content_type === hashtagFilter));
        }
        const ageGenderSplitData = response?.data?.rows?.age_gender_split;
        if (Array.isArray(ageGenderSplitData) && ageGenderSplitData.length !== 0) {

          let maleSplit = ageGenderSplitData.length !== 0 && ageGenderSplitData.filter(entry => entry.gender === "male").reduce((total, entry) => total + entry.total_percentage, 0);
          let femaleSplit = ageGenderSplitData.length !== 0 && ageGenderSplitData.filter(entry => entry.gender === "female").reduce((total, entry) => total + entry.total_percentage, 0);
          setMaleGenderSplit(maleSplit)
          setFemaleGenderSplit(femaleSplit)
          const genderSplitData = [
            { name: "Male", y: maleSplit, color: "#497FD6" },
            { name: "Female", y: femaleSplit, color: "#DD5A5D" },
          ];
          setGenderSplit(genderSplitData);
        } else {
          // localService.toastify(response.data.status.message, "info", 1000);
        }

        //age-gender-column-data
        const ageGenderData = response?.data?.rows?.age_gender;
        if (Array.isArray(ageGenderData) && ageGenderData.length !== 0) {

          // let fGenderArray: any = ageGenderData?.filter((item) => item.gender.includes("female"));
          // let mGenderArray: any = ageGenderData?.filter((item) => item.gender === "male");
          let fGenderArray = ageGenderData
            .filter((item) => item.gender === "female")
            .map((item) => item.value);

          let mGenderArray = ageGenderData
            .filter((item) => item.gender === "male")
            .map((item) => item.value);

          let genderArrayLabelSet = new Set(ageGenderData.map(item => item.age_range_yt.replace(/[female, male]/g, '')));
          let genderLabel: any = [...genderArrayLabelSet];
          setGenderArrayLabel(genderLabel)
          const newColumnChartData = [
            {
              name: "Male",
              data: mGenderArray,
              color: '#497FD6'
            },
            {
              name: "Female",
              data: fGenderArray,
              color: '#DD5A5D'
            },
          ];

          setColumnChartData(newColumnChartData);
        } else {
          // localService.toastify(response.data.status.message, "info", 1000);
        }

        //channel-insight-views
        const channelViewData = response?.data?.rows?.view;
        if (Array.isArray(channelViewData) && channelViewData.length > 0) {

          let channelView: any = channelViewData.length > 0 && channelViewData.map(item => [convertToUTC(item.day), item.views])
          const newStockChartData = [
            {
              name: 'views',
              data: channelView
            }

          ]
          setViewStockChartData(newStockChartData)
        } else {
          // localService.toastify(response.data.status.message, "info", 1000);
        }

        //channel-insight-min-watch
        const minViewData = response?.data?.rows?.estimated_min_watch;
        if (Array.isArray(minViewData)) {
          let minView: any = minViewData.map(item => ([convertToUTC(item.day), item.estimated_min]));

          const estMinStockChartData = [
            {
              name: 'Total Minutes Watched',
              data: minView
            }

          ]
          setMinStockChartData(estMinStockChartData)
        } else {
          // localService.toastify(response.data.status.message, "info", 1000);
        }


        //geo-insight-views
        const geoViewData = response?.data?.rows?.geo_view;
        if (Array.isArray(geoViewData) && geoViewData.length > 0) {
          set_geo_view(response?.data?.rows?.geo_view);
          const geoCViewData = geoViewData.map((item, index) => ({
            name: countryNameMapping[item.country] || item.country,
            y: item.views,
            color: getColorBasedOnIndex(index),
          }));

          setGeoViewStockChartData(geoCViewData)

        } else {
          // localService.toastify(response.data.status.message, "info", 1000);
        }

        //geo-insight-estimated-minutes
        const geoEstMinData = response?.data?.rows?.geo_estimated_min_watch;
        if (Array.isArray(geoEstMinData) && geoEstMinData.length > 0) {

          let country = geoEstMinData.map(item => item.country);
          country = country.map(name => countryNameMapping[name] || name);

          let dataMin = geoEstMinData.map(item => item.estimated_min);

          const countryData = [
            {
              name: "Minutes",
              data: dataMin
            }
          ];
          setGeoEstMinChartData(countryData)
          setCountryName(country)
          // const geoEstMinViewData = geoEstMinData.map((item, index) => ({
          //   name: item.country,
          //   data: item.estimated_min,
          //   color: getColorBasedOnIndex(index),
          // }));
        } else {
          // localService.toastify(response.data.status.message, "info", 1000);
        }

        //geo-insight-averagev-views-duration and percentage
        const geoAvgViewData = response?.data?.rows?.geo_avg_view;
        if (Array.isArray(geoAvgViewData) && geoAvgViewData.length > 0) {
          let country = geoAvgViewData.map(item => item.country);
          country = country.map(name => countryNameMapping[name] || name);

          let dataAvgMin = geoAvgViewData.map(item => item.avg_views_duration);
          const geoEstMinViewData = [
            {
              name: "Minutes",
              data: dataAvgMin
            }
          ];
          setGeoAvgViewPieChartData(geoEstMinViewData)
          setCountryNameAvg(country)

          // const geoCAvgViewData = geoAvgViewData.map((item, index) => ({
          //   name: item.country,
          //   y: item.avg_views_duration,
          //   color: getColorBasedOnIndex(index),
          // }));
          // setGeoAvgViewPieChartData(geoCAvgViewData)

          //Average-view-percentage
          const geoCAvgPerViewData = geoAvgViewData.map((item, index) => ({
            name: countryNameMapping[item.country] || item.country,
            y: item.perce,
            color: getColorBasedOnIndex(index),
          }));

          setGeoAvgViewPerPieChartData(geoCAvgPerViewData)

        } else {
          // localService.toastify(response.data.status.message, "info", 1000);
        }

        //Device-insight-views
        const deviceViewData = response?.data?.rows?.device_insight;
        if (Array.isArray(deviceViewData) && deviceViewData.length > 0) {

          let mobileView: any = deviceViewData.map(item => [convertToUTC(item.DAY), item.mobile_views])
          let tabletView: any = deviceViewData.map(item => [convertToUTC(item.DAY), item.tablet_views])
          let tvView: any = deviceViewData.map(item => [convertToUTC(item.DAY), item.tv_views])

          const deviceVStockChartData = [
            {
              name: 'Mobile',
              data: mobileView
            },
            {
              name: 'Tablet',
              data: tabletView
            },
            {
              name: 'TV',
              data: tvView
            }

          ]
          setDeviceViewStockChartData(deviceVStockChartData)
        } else {
          // localService.toastify(response.data.status.message, "info", 1000);
        }

        //Device-insight-avg-views
        // const avgDeviceViewData = response?.data?.rows?.device_insight_avg;
        // if (Array.isArray(avgDeviceViewData) && avgDeviceViewData.length > 0) {

        //   let mobileView;
        //   avgDeviceViewData.forEach(item => { mobileView = item.avg_mobile_views });
        //   let tabletView;
        //   avgDeviceViewData.forEach(item => { tabletView = item.avg_tablet_views });
        //   let tvView;
        //   avgDeviceViewData.forEach(item => { tvView = item.avg_tv_views });

        //   const avgGeoCViewData = [
        //     { name: "Mobile", y: mobileView, color: "#f9d1d1" },
        //     { name: "Tablet", y: tabletView, color: "#ffa4B6" },
        //     { name: "TV", y: tvView, color: "#f765a3" }
        //   ];
        //   setDeviceAvgViewPieChartData(avgGeoCViewData)


        // } else {
        // localService.toastify(response.data.status.message, "info", 1000);
        // }

        const avgDeviceViewData = response?.data?.rows?.device_insight_avg;

        if (Array.isArray(avgDeviceViewData) && avgDeviceViewData.length > 0) {
          const deviceView = avgDeviceViewData[0]; // Only one item in array, as per your structure

          const mobileView = deviceView.avg_mobile_views || 0;
          const tabletView = deviceView.avg_tablet_views || 0;
          const tvView = deviceView.avg_tv_views || 0;

          const total = mobileView + tabletView + tvView;

          const avgGeoCViewData = total > 0 ? [
            {
              name: "Mobile",
              y: parseFloat(((mobileView / total) * 100).toFixed(1)),
              color: "#3498db"
            },
            {
              name: "Tablet",
              y: parseFloat(((tabletView / total) * 100).toFixed(1)),
              color: "#ff69b4"
            },
            {
              name: "TV",
              y: parseFloat(((tvView / total) * 100).toFixed(1)),
              color: "#a569bd"
            }
          ] : [];

          setDeviceAvgViewPieChartData(avgGeoCViewData);
        }



        //Device-insight-estimated-minutes
        const deviceEstMinData = response?.data?.rows?.device_insight_est_min;
        if (Array.isArray(deviceEstMinData) && deviceEstMinData.length > 0) {

          let mobileEstMin: any = deviceEstMinData.map(item => [convertToUTC(item.DAY), item.estimated_min_mobile])
          let tabletEstMin: any = deviceEstMinData.map(item => [convertToUTC(item.DAY), item.estimated_min_tablet])
          let tvEstMin: any = deviceEstMinData.map(item => [convertToUTC(item.DAY), item.estimated_min_tv])

          const deviceVMinStockChartData = [
            {
              name: 'Mobile',
              data: mobileEstMin
            },
            {
              name: 'Tablet',
              data: tabletEstMin
            },
            {
              name: 'TV',
              data: tvEstMin
            }

          ]
          setDeviceMinStockChartData(deviceVMinStockChartData)
        } else {
          // localService.toastify(response.data.status.message, "info", 1000);
        }


        //Device-insight-avg-estimated-mins
        const avgDeviceEstMinData = response?.data?.rows?.device_insight_est_min_avg;
        if (Array.isArray(avgDeviceEstMinData)) {

          let mobileEstMin;
          avgDeviceEstMinData.forEach(item => { mobileEstMin = item.avg_mobile_estimated_minutes_watched });
          let tabletEstMin;
          avgDeviceEstMinData.forEach(item => { tabletEstMin = item.avg_tablet_estimated_minutes_watched });
          let tvEstMin;
          avgDeviceEstMinData.forEach(item => { tvEstMin = item.avg_tv_estimated_minutes_watched });

          const avgDeviceVMinStockChartData = [
            { name: "Mobile", y: mobileEstMin, color: "#f9d1d1" },
            { name: "Tablet", y: tabletEstMin, color: "#ffa4B6" },
            { name: "TV", y: tvEstMin, color: "#f765a3" }
          ];
          setAvgDeviceMinPieChartData(avgDeviceVMinStockChartData)
        } else {
          // localService.toastify(response.data.status.message, "info", 1000);
        }

        //Social-share-data
        const socialShareData = response?.data?.rows?.social_shares;

        if (Array.isArray(socialShareData)) {
          const threshold = 1; // Percentage threshold
          let smallPercentageData = [];
          let combinedShares = 0;

          const filteredData = socialShareData.filter((item) => {
            if (item.perce < threshold || item.sharing_service === "OTHER") {
              combinedShares += item.shares; // Add shares of small percentages and "OTHER"
              smallPercentageData.push(item); // Collect small percentage items
              return false; // Exclude from main data
            }
            return true; // Include items with perce >= threshold
          });

          // Find existing "Other" or "Others" in filteredData
          let existingOthersIndex = filteredData.findIndex(
            (item) =>
              item.sharing_service.toLowerCase() === "other" ||
              item.sharing_service.toLowerCase() === "others"
          );

          if (combinedShares > 0) {
            const totalShares = socialShareData.reduce((sum, i) => sum + i.shares, 0);
            const combinedOthers = {
              sharing_service: "Others",
              y: combinedShares,
              perce: parseFloat(((combinedShares / totalShares) * 100).toFixed(2)),
              color: "#ccc",
            };

            if (existingOthersIndex !== -1) {
              // If "Other" or "Others" already exists, merge values
              filteredData[existingOthersIndex].y += combinedOthers.y;
              filteredData[existingOthersIndex].perce += combinedOthers.perce;
              filteredData[existingOthersIndex].sharing_service = "Others"; // Standardize name
            } else {
              // Otherwise, push new "Others" entry
              filteredData.push(combinedOthers);
            }
          }

          const socialShareViewData = filteredData.map((item, index) => ({
            name: (item.name || item.sharing_service).toLowerCase() === "whats_app"
              ? "WhatsApp"
              : (item.name || item.sharing_service).replace(/_/g, " "),
            y: item.perce || item.y || item.shares,
            color: getColorBasedOnIndex(index),
          }));

          setSocialSharePieChartData(socialShareViewData);
        }


        // SUBSCRIBER GROWTH DATA
        const subscribersGrowthData = response?.data?.rows?.subscriber_growth;
        if (Array.isArray(subscribersGrowthData) && subscribersGrowthData.length > 0) {

          let subscriberGrowth: any = subscribersGrowthData.length > 0 && subscribersGrowthData.map(item => [convertToUTC(item.day), item.views])

          const newSubscriberGrowthChartData = [
            {
              name: 'views',
              data: subscriberGrowth
            }

          ]
          setViewSubscriberGrowthData(newSubscriberGrowthChartData)
        } else {
          // localService.toastify(response.data.status.message, "info", 1000);
        }

      } else {
        if (response.status === gtUtil.Constants.DB_QUERY_NO_RECORD_FOUND) {
          set_connected_profile(true);
        }
      }

      if (responseEngagementYt.status === gtUtil.Constants.SUCCESS) {
        setEngagementData(responseEngagementYt.data.rows);
      }

      if (responseCommentsYt.status === gtUtil.Constants.SUCCESS) {
        setCommentsData(responseCommentsYt.data.rows);
      }

    } catch (error) {
      // console.log(`inflProfileService error :: ${JSON.stringify(error)}`);
    } finally {
      setIsLoading(false);
      setDataInitialized(true);
    }
  }

  // const fetchYtPosts = async (value: number, unit: string) => {
  //   try {
  //     const responsePostYt = await inflProfileService.getProfilePostYt({
  //       sm_id: selectInflu[0].yt_id,
  //       influencer_id:
  //         props?.UserReducer?.account_type === 'Influencer' ||
  //           props?.UserReducer?.account_type === 'Talent Partner'
  //           ? props?.UserReducer?.influencer_id
  //           : urlParams.get('influencerId') || 0,
  //       filter_value: value,
  //       filter_unit: unit,
  //     });
  //     if (responsePostYt?.status === gtUtil.Constants.SUCCESS) {
  //       setPostData(responsePostYt.data.rows);
  //     } else {
  //       setPostData(null);
  //     }
  //   } catch (error) {
  //     console.error('Error fetching YT posts:', error);
  //     setPostData(null);
  //   }
  // };


  const fetchYtPosts = async (
    type: 'videos' | 'shorts',
    filterType: any,
    page: number
  ) => {
    const [value, unit] = timeRangePost.split('_');
    const res = await inflProfileService.getProfilePostYt({
      sm_id: selectInflu[0].yt_id,
      influencer_id: shareMode
        ? selectInflu?.[0]?.influencer_id
        : (props?.UserReducer?.account_type === 'Influencer' ||
          props?.UserReducer?.account_type === 'Talent Partner'
          ? props?.UserReducer?.influencer_id
          : urlParams.get('influencerId') || 0),
      filter_value: value,
      filter_unit: unit,
      type,
      filter_type: filterType,
      page,
      limit: 10
    });

    if (res.status === gtUtil.Constants.SUCCESS) {
      if (type === 'videos') {
        setVideoPostData(prev => ({
          ...prev,
          [filterType]: page === 1
            ? res.data.rows
            : [...(prev[filterType] || []), ...res.data.rows]
        }));
      } else {
        setShortPostData(prev => ({
          ...prev,
          [filterType]: page === 1
            ? res.data.rows
            : [...(prev[filterType] || []), ...res.data.rows]
        }));
      }
    }
  };


  const fetchYtEngagements = async (value: number, unit: string) => {
    try {
      const responseEngagementYt = await inflProfileService.getProfileEngagementYt({
        sm_id: selectInflu[0].yt_id,
        influencer_id: props?.UserReducer?.account_type === 'Influencer' || props?.UserReducer?.account_type === 'Talent Partner'
          ? props?.UserReducer?.influencer_id
          : urlParams.get('influencerId') || 0,
        filter_value: value,
        filter_unit: unit,
      });
      if (responseEngagementYt?.status === gtUtil.Constants.SUCCESS) {
        setEngagementData(responseEngagementYt.data.rows);
      } else {
        setEngagementData(null);
      }
    } catch (error) {
      console.error('Error fetching YT posts:', error);
      setEngagementData(null);
    }
  };

  useEffect(() => {
    _InfluencerList();

  }, [props?.UserReducer?.brand_id, props?.UserReducer?.user_id]);

  function _InfluencerList() {
    if (shareMode) return; // no logged-in user on the public share view
    CampaignService.influencerList({
      user_id: props.UserReducer.user_id,
      brand_id: props.UserReducer.brand_id,
    }).then((res: any) => {
      if (res.data.status === 1) {
        setInfluencerList(res.data.rows);
      } else {
        setInfluencerList(null);
      }
    });
  }

  const [social_loader, set_social_loader] = useState<boolean>(false);
  const [loadingYt, setLoadingYt] = React.useState(false);
  const [googleaccount, setGoogleAccount] = React.useState<any>([]);
  const [disconnectButtonGoogle, setDisconnectButtonGoogle] =
    React.useState(true);
  const [connectButtonGoogle, setConnectButtonGoogle] =
    React.useState('Connect');
  const [yt_data, set_yt_data] = useState({});
  const [socialRestrictionPopup, set_socialRestrictionPopup] = useState({
    youtube: false,
    instagram: false
  })
  async function updateUserReducer() {
    let latestUserReducerData = await userService.getUpdatedUserReducer(props.UserReducer);
    if (![undefined, null, ''].includes(latestUserReducerData)) {
      props.updateUser(latestUserReducerData)
    }

  }
  async function getYoutubeAccounts() {
    try {
      setLoadingYt(true)
      handlesService
        .getGoogleConnectedAccounts(
          props?.UserReducer?.influencer_id
        )
        .then((res: any) => {
          if (res?.data?.rows.length > 0) {
            const connectedAccountData = res?.data?.rows.filter(
              (filter: any) => filter.token_status === 'Connected'
            );
            setGoogleAccount(connectedAccountData);
            setDisconnectButtonGoogle(false);
            setConnectButtonGoogle('Reconnect');
          }
        })
        .catch((err: any) => console.log(err));
      updateUserReducer();
    } catch (err) {
      // console.log(err)
    } finally {
      setLoadingYt(false)
    }
  }
  const loginGoogleyt = async () => {
    try {
      const response = await handlesService.googleConnected();

      if (response.status === gtUtil.Constants.SUCCESS) {
        const popup = window.open(
          response.data.url,
          "GoogleOAuthPopup",
          "width=500,height=600,left=100,top=100"
        );

        if (!popup) {
          toast.error("Popup blocked. Please allow popups and try again.");
          return;
        }

        const channel = new BroadcastChannel('oauth-channel');
        channel.onmessage = async (event) => {
          if (event.data?.type === 'social-auth-success') {
            const authCode = event.data.code;
            channel.close();

            try {
              set_social_loader(true);

              // Send auth code to backend
              const tokenResponse = await handlesService.postGoogleConnected({
                code: authCode,
                influencer_id: props.UserReducer.influencer_id
              });

              if (tokenResponse.status === gtUtil.Constants.SUCCESS) {
                updateUserReducer();
                getYoutubeAccounts();
                setConnect(!connect);
                set_social_loader(false);
              } else {
                if (tokenResponse.info === 'Social account already connected to the other account.') {
                  set_yt_data(tokenResponse.data);
                  set_socialRestrictionPopup(prevState => ({
                    ...prevState,
                    youtube: true
                  }));
                }
              }
            } catch (error) {
              console.error("Error processing YouTube auth response:", error);
              toast.error("YouTube authentication failed.");
            } finally {
              set_social_loader(false);
            }
          }
        };
      } else {
        console.error("Error fetching Google OAuth URL:", response.info);
        toast.error("Failed to get Google authentication URL.");
      }
    } catch (error) {
      console.error("Login Error:", error);
      toast.error("Google Connect failed");
    } finally {
      set_social_loader(false);
    }
  };

  const handleCloseSocialPopup_YT = async (id: any) => {
    set_socialRestrictionPopup(prevState => ({
      ...prevState,
      youtube: false
    }));

    try {
      const response = await handlesService.continueConnect({
        yt_id: id,
        influencer_id: props?.UserReducer?.influencer_id,
        continues: false,
      });

      if (response.status === gtUtil.Constants.SUCCESS) {
        updateUserReducer()
        setConnect(!connect);
      } else {
        // console.log('Error occurred');
      }
    } catch (error) {
      console.error('API Error:', error);
    } finally {
      set_social_loader(false);
    }
  };

  const handleContinueConnect_YT = async (id: any) => {
    set_socialRestrictionPopup(prevState => ({
      ...prevState,
      youtube: false
    }));

    try {
      const response = await handlesService.continueConnect({
        yt_id: id,
        influencer_id: props?.UserReducer?.influencer_id,
        continues: true,
      });

      if (response.status === gtUtil.Constants.SUCCESS) {
        updateUserReducer();
        setConnect(!connect);
      } else {
        // console.log('Error occurred');
      }
    } catch (error) {
      console.error('API Error:', error);
    } finally {
      set_social_loader(false);
    }
  };
  useBodyClass("page-profile-insight")
  useBodyClass("profile-insight-yt")

  const LanguagesList = [
    {
      "id": 1,
      "name": "English",
      "percentage": 50,
    }, {
      "id": 2,
      "name": "Hindi",
      "percentage": 20,
    },
    {
      "id": 3,
      "name": "Tamil",
      "percentage": 15,
    },
  ]

  const [paidTabKey, setPaidTabKey] = useState("positive");
  const [organicTabKey, setOrganicTabKey] = useState("positive");
  const hasItems = (data: any) =>
  Object.values(data || {}).some((v: any) => v?.length > 0);


  const renderCommentList = (comments: any[]) => (
    <ul className='comment-tab-content-list'>
      {comments.map((item, index) => (
        <li className='comment-tab-content-item' key={index}>
          <img
            className='comment-tab-content-item-img'
            src={item.author_profile_url || DefaultUserProfile.influencer_unknown_default}
            alt=''
            style={{ width: '40px', height: '40px', borderRadius: '50%' }}
          />
          {/* <div className='comment-tab-content-item-detail'> */}
          {/* <span className='comment-tab-content-item-user'>{item.user_commenting}</span> */}
          {/* <span className='comment-tab-content-item-user-comment'>{item.comment}</span>
          </div> */}
          <div style={{ flex: 1 }} className='comment-tab-content-item-detail'>
            {/* <span className='comment-tab-content-item-user-comment'>{item.comment}</span> */}
            <span
              className="comment-tab-content-item-user-comment"
              dangerouslySetInnerHTML={{ __html: sanitizeHtml(item.comment) }}
            />
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                marginTop: '6px',
                fontSize: '13px',
                color: '#64748B',
                fontWeight: 700,
              }}
            >
              <span>{item.like_count || 0} Like</span>
              <span>{item.reply_count || 0} Replies</span>
            </div>
          </div>
        </li>
      ))}
    </ul>
  );


  //   const renderCommentList = (comments: any[]) => (
  //   <ul className='comment-tab-content-list'>
  //     {comments.map((item, index) => (
  //       <li className='comment-tab-content-item' key={index} style={{ display: 'flex', marginBottom: '16px' }}>
  //         <img
  //           src={item.author_profile_url || DefaultUserProfile.influencer_unknown_default}
  //           alt=''
  //           style={{
  //             width: '40px',
  //             height: '40px',
  //             borderRadius: '50%',
  //             objectFit: 'cover',
  //             marginRight: '12px',
  //           }}
  //         />
  //         <div style={{ flex: 1 }}>
  //           <div
  //             style={{
  //               background: '#f0f2f5',
  //               borderRadius: '18px',
  //               padding: '10px 14px',
  //               fontSize: '14px',
  //               lineHeight: '1.5',
  //               color: '#050505',
  //             }}
  //           >
  //             {item.comment}
  //           </div>

  //           <div
  //             style={{
  //               display: 'flex',
  //               alignItems: 'center',
  //               gap: '12px',
  //               marginTop: '6px',
  //               fontSize: '13px',
  //               color: '#65676b',
  //               fontWeight: 500,
  //             }}
  //           >
  //             <span>{item.like_count || 0} Like</span>
  //             <span>{item.reply_count || 0} Replies</span>
  //           </div>
  //         </div>
  //       </li>
  //     ))}
  //   </ul>
  // );

  const browserData = [
    ['Chrome', 35],
    ['Edge', 25],
    ['Firefox', 20],
    ['Safari', 15],
    ['IE', 5],
  ];

  const handlePointClick = (name: string, value: number) => {
    alert(`Clicked on ${name} with value ${value}`);
  };

  const options: Highcharts.Options = {
    chart: {
      type: 'pie',
      backgroundColor: 'transparent',
      height: 200,

    },
    title: {
      text: undefined,
    },
    tooltip: {
      enabled: false,
    },
    plotOptions: {
      pie: {
        innerSize: '65%',

        dataLabels: {
          enabled: false,
          borderRadius: 4
        },
        borderWidth: 4,
        borderRadius: 4,
        borderColor: "#f9f9f9"
      },
    },
    colors: ['#3498db', '#ff69b4', '#a569bd'],
    series: [
      {
        type: 'pie',
        name: 'Devices',
        data: [
          { name: 'Mobile', y: 61 },
          { name: 'Tablet', y: 24 },
          { name: 'TV', y: 15 },
        ],
      },
    ],
    credits: {
      enabled: false,
    },
    exporting: {
      enabled: false
    }
  };
  const [brandSelectedCategory, setBrandSelectedCategory] = useState('All');
  const BrandcategoryTab = [
    'All',
    'E-Commerce',
    'Personal Care and Hygiene',
    'Media and Entertainment',
    'Healthcare',
    'Pet Care',
  ];

  const brandData = [
    { name: 'Godrej', posts: 28, category: 'Personal Care and Hygiene', img: godrej },
    { name: 'Myntra', posts: 15, category: 'E-Commerce', img: 'https://placehold.co/60?text=M' },
    { name: 'Ajio', posts: 15, category: 'E-Commerce', img: 'https://placehold.co/60?text=A' },
    { name: 'Netflix', posts: 8, category: 'Media and Entertainment', img: 'https://placehold.co/60?text=N' },
    { name: 'Himalaya', posts: 15, category: 'Personal Care and Hygiene', img: 'https://placehold.co/60?text=H' },
    { name: 'Mamaearth', posts: 10, category: 'Personal Care and Hygiene', img: mama },
    { name: 'Parachute', posts: 5, category: 'Personal Care and Hygiene', img: 'https://placehold.co/60?text=P' },
    { name: 'Godrej', posts: 28, category: 'Personal Care and Hygiene', img: godrej },
    { name: 'Myntra', posts: 15, category: 'E-Commerce', img: 'https://placehold.co/60?text=M' },
    { name: 'Ajio', posts: 15, category: 'E-Commerce', img: 'https://placehold.co/60?text=A' },
    { name: 'Netflix', posts: 8, category: 'Media and Entertainment', img: 'https://placehold.co/60?text=N' },
    { name: 'Himalaya', posts: 15, category: 'Personal Care and Hygiene', img: 'https://placehold.co/60?text=H' },
    { name: 'Mamaearth', posts: 10, category: 'Personal Care and Hygiene', img: mama },
    { name: 'Parachute', posts: 5, category: 'Personal Care and Hygiene', img: 'https://placehold.co/60?text=P' },
  ];

  const sliderSettings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 7.5,
    slidesToScroll: 1,
    swipeToSlide: true,
    responsive: [
      {
        breakpoint: 768,
        settings: { slidesToShow: 3 },
      },
      {
        breakpoint: 480,
        settings: { slidesToShow: 2 },
      },
    ],
  };
  const BrandsFilteredData =
    brandSelectedCategory === 'All'
      ? brandData
      : brandData.filter((b) => b.category === brandSelectedCategory);

  const [timeRangeEngagement, setTimeRangeEngagement] = useState('6_months');
  const [commentFilter, setCommentFilter] = useState('organic');

  const handlePostChange = async (event: any) => {
    const newRange = event.target.value;
    setTimeRangePost(newRange);
    setVideoPostData({});
    setShortPostData({});
  };

  const handleEngagementChange = async (event: any) => {
    const newRange = event.target.value;
    setTimeRangeEngagement(newRange);

    const [value, unit] = newRange.split('_');
    await fetchYtEngagements(Number(value), unit);
  };

  const handleCommentFilterChange = async (event: any) => {
    const newRange = event.target.value;
    setCommentFilter(newRange);
  };

  const handleHashtagFilterChange = (event: any) => {
    const newValue = event.target.value;
    setHashtagFilter(newValue);
    setHashtags(allHashtags.filter((item) => item.content_type === newValue));
  };

  const handleSimilarProfileClick = (influencer: any) => {
    // Public share view: the target profile pages are auth-gated, so don't
    // navigate (it would bounce the viewer to login).
    if (shareMode) return;
    window.open(`/brand/profile-insight-yt?sm_id=${influencer.yt_id}&influencerId=${influencer.influencer_id}`, "_blank");
  };

  // -------------------- SHARE PROFILE (public link) --------------------
  // Mirrors the IG profile share flow. Backend returns a self-contained JWT
  // link, so no db changes are required.
  const [openSharePopup, setOpenSharePopup] = useState(false);
  const [shareURL, setShareURL] = useState("");
  const [shareLoading, setShareLoading] = useState(false);

  const shareSmId = selectInflu?.[0]?.yt_id;
  const shareInfluencerId = selectInflu?.[0]?.influencer_id;

  const fetchShareURL = async (): Promise<string> => {
    if (shareURL) return shareURL;
    if (!shareSmId || !shareInfluencerId) {
      localService.toastify("Profile is still loading, please try again.", "info", 1000);
      return "";
    }
    try {
      setShareLoading(true);
      const res = await inflProfileService.profileInsightYtSharePublicLink({
        sm_id: shareSmId,
        influencer_id: shareInfluencerId,
      });
      if (res?.data?.status) {
        const url = res?.data?.url || "";
        setShareURL(url);
        return url;
      }
      console.error("Error fetching share URL:", res?.data?.message);
      return "";
    } catch (error) {
      console.error("Error while fetching YouTube profile share URL:", error);
      return "";
    } finally {
      setShareLoading(false);
    }
  };

  const handleOpenSharePopup = async () => {
    setOpenSharePopup(true);
    await fetchShareURL();
  };

  const handleCloseSharePopup = () => {
    setOpenSharePopup(false);
  };

  const handleCopyShareLink = async () => {
    const url = await fetchShareURL();
    if (url) {
      navigator.clipboard.writeText(url);
      localService.toastify("Link Copied", "success", 1000);
    }
  };

  const [showRefreshPopup, setShowRefreshPopup] = useState<boolean>(false);
  const [refreshPopupMessage, setRefreshPopupMessage] = useState<string>("");

  const handleCloseRefreshPopup = () => {
    setShowRefreshPopup(false);
  };

  const handleUpdateProfileRequest = async () => {
    if (requestingUpdate) return;
    if (onRequestUpdate) {
      setRefreshPopupMessage("Your request is already in the queue. Please check back later.");
      setShowRefreshPopup(true);
      return;
    }
    setRequestingUpdate(true);
    try {
      const response: any = await inflProfileService.requestProfileUpdate({
        sm_id: ytInfluencerData?.detail?.[0]?.yt_id,
        platform: 'Youtube',
        user_id: props.UserReducer.user_id,
        account_id: props.UserReducer.account_id,
        brand_id: props.UserReducer.brand_id,
        influencer_id: props?.UserReducer?.account_type === 'Influencer' || props?.UserReducer?.account_type === 'Talent Partner'
          ? props?.UserReducer?.influencer_id
          : urlParams.get('influencerId') || 0
      });
      if (response.status === gtUtil.Constants.SUCCESS) {
        setOnRequestUpdate(true);
        setRefreshPopupMessage("Your request has been processed. Please visit your profile again later.");
        setShowRefreshPopup(true);
      } else {
        localService.toastify(response?.message || "Unable to request profile update", "error", 1000);
      }
    } catch (error) {
      console.error('Error requesting profile update:', error);
      localService.toastify("Unable to request profile update", "error", 1000);
    } finally {
      setRequestingUpdate(false);
    }
  };


  if (shareMode && invalidShareLink) {
    return (
      <div style={{ textAlign: "center", padding: "4rem 1rem" }}>
        This share link is invalid or has expired.
      </div>
    );
  }

  return (
    <>
      {!dataInitialized ? <ContentLoading width="125" height="125" /> : ((props?.UserReducer?.account_type === 'Influencer' || props?.UserReducer?.account_type === 'Talent Partner') && connected_profile) ? (
        <div style={{ textAlign: "center" }}>
          Please <span style={{ borderBottom: '1px solid #2b2b2b', cursor: 'pointer', fontWeight: 'bold' }} onClick={() => loginGoogleyt()}>verify</span> your YouTube account to retrieve the profile.
        </div>
      ) : (
        <div className="container">
          {/* Brands: Instagram | YouTube when the creator has both (e.g. a multi-platform campaign). */}
          {(props?.UserReducer?.account_type === 'Brand' || props?.UserReducer?.account_type === 'Agency') && Number(urlParams.get('influencerId')) > 0 && (
            <React.Suspense fallback={null}>
              <CreatorPlatformSwitch
                plain
                brandId={Number(props?.UserReducer?.brand_id) || 0}
                influencerId={Number(urlParams.get('influencerId')) || 0}
                platform="youtube"
              />
            </React.Suspense>
          )}
          <div className="influencer-profile">
            {/* <div className="common-tab mb-0 d-lg-none common-tab-mobile">
                <span className="d-none common-tab-menu">Instagram</span>
                <span className="active common-tab-menu">YouTube</span>
              </div> */}
            <div className="influencer-profile__left">
              <YTInfluencerProfileLeft accountType={props?.UserReducer?.account_type} onRequestUpdate={onRequestUpdate} handleUpdateProfileRequest={handleUpdateProfileRequest} requestingUpdate={requestingUpdate} loading={loading} ytInfluencerData={ytInfluencerData} email={email} phone={phone} location={location} language={language} category={categoriesData} subscription_status={subscription_status} />

            </div>
            <div className="influencer-profile__right">
              <div className="d-flex flex-wrap w-100 align-items-center mb-3">
                {/* <div className="common-tab mb-0 d-none d-lg-inline-flex"> */}
                {/* <span className="active common-tab-menu">Instagram</span>  */}
                {/* <span className="active common-tab-menu"><IconYouTube width="22px" />{ytInfluencerData && ytInfluencerData?.detail?.[0]?.custom_url}</span> */}
                {/* </div>  */}

                <div className="d-none d-lg-flex align-items-center">
                  {ytInfluencerData?.detail?.[0]?.custom_url && <IconYouTube width="20px" height="20px" className="mb-1" />}
                  <Link target="_blank" className="btn btn-text-link" to={`https://www.youtube.com/channel/${ytInfluencerData?.detail?.[0]?.channel_id}`}>
                    <span>{ytInfluencerData?.detail?.[0]?.custom_url}</span>
                  </Link>
                </div>

                {(props?.UserReducer?.account_type === 'Brand' || props?.UserReducer?.account_type === 'Agency') && (
                  <div className='infl-profile-detail-action  ms-auto'>
                    <React.Suspense fallback={null}>
                      <CreatorQuickActions
                        platform="youtube"
                        buttonClassName="btn btn-text-link me-2"
                        creator={{
                          influencerId: Number(selectInflu?.[0]?.influencer_id) || 0,
                          smId: Number(selectInflu?.[0]?.yt_id) || 0,
                          platform: 'YouTube',
                          accountId: Number(selectInflu?.[0]?.account_id) || 0,
                          userId: Number(selectInflu?.[0]?.user_id) || 0,
                          name: String(selectInflu?.[0]?.name || selectInflu?.[0]?.title || ''),
                          username: String(selectInflu?.[0]?.custom_url || selectInflu?.[0]?.title || ''),
                          image: selectInflu?.[0]?.gcp_profile_image_url || selectInflu?.[0]?.profile_image_url || null,
                        }}
                      />
                    </React.Suspense>
                    <span
                      className="cursor-pointer btn btn-primary d-inline-flex align-items-center"
                      onClick={handleOpenSharePopup}
                    >
                      <MaterialSymbol className="me-1" iconName="share" fontweight="200" fontSize="18px" />
                      Share
                    </span>
                  </div>
                )}
              </div>
              {/* <Link
                  target="_blank"
                  to={`https://www.youtube.com/channel/${ytInfluencerData && ytInfluencerData?.detail?.[0]?.channel_id}`}
                  className="influencer-profile__social-chan d-none d-lg-flex"
                >
                  <span className="influ-prof-info-social-username d-flex justify-content-center align-items-baseline">

                    {ytInfluencerData && ytInfluencerData?.detail?.[0]?.custom_url}
                  </span>
                </Link> */}
              {/* FOLLOWER SEC */}
              <div className="follower-sec follower-sec-black">
                <FollowerCard loading={loading} title="Subscribers" iconName="" value={methods.formatInfluencerProfileNumber(ytInfluencerData?.detail?.[0]?.subscriber_count)} />
                {EngagementData && EngagementData?.engagement?.overall?.engagement_rate && <FollowerCard loading={loading} title="Engagement Rate" iconName="" value={`${EngagementData?.engagement?.overall?.engagement_rate}%`} />}
                {/* <FollowerCard loading={loading} title="Avg. Views" iconName="" value={methods.formatInfluencerProfileNumber(ytInfluencerData?.detail?.[0]?.avg_views)} /> */}
                {EngagementData && EngagementData?.engagement?.overall?.avg_views ? <FollowerCard loading={loading} title="Avg. Views" iconName="" value={methods.formatInfluencerProfileNumber(EngagementData?.engagement?.overall?.avg_views)} /> :
                  <FollowerCard loading={loading} title="Avg. Views" iconName="" value={methods.formatInfluencerProfileNumber(ytInfluencerData?.detail?.[0]?.avg_views)} />}

              </div>
              <div className="follower-sec follower-sec-grey">
                {EngagementData && (EngagementData?.engagement?.overall?.avg_likes || EngagementData?.engagement?.overall?.avg_likes == 0) && <FollowerCard loading={loading} title="Avg. Likes" iconName="" value={methods.formatInfluencerProfileNumber(EngagementData?.engagement.overall.avg_likes)} />}
                {EngagementData && (EngagementData?.engagement?.overall?.avg_comments || EngagementData?.engagement?.overall?.avg_comments == 0) && <FollowerCard loading={loading} title="Avg. Comments" iconName="" value={methods.formatInfluencerProfileNumber(EngagementData?.engagement.overall.avg_comments)} />}
                {EngagementData && (EngagementData?.engagement?.overall?.frequency_per_week || EngagementData?.engagement?.overall?.frequency_per_week == 0) && <FollowerCard loading={loading} title="Frequency (per week)" iconName="" value={EngagementData?.engagement.overall.frequency_per_week} />}
                {ytInfluencerData?.detail && <FollowerCard loading={loading} title="Total Videos" iconName="" value={methods.formatInfluencerProfileNumber(ytInfluencerData?.detail?.[0]?.video_count)} />}
              </div>
              {(ytInfluencerData?.metrics?.Audience_Retention_Rate || ytInfluencerData?.metrics?.Avg_Video_Views_to_Subscribers ||
                ytInfluencerData?.metrics?.Avg_short_Views_to_Subscribers) &&
                <>
                  <strong className='influencer-profile__common__title audience'>
                    Key Metrics
                  </strong>
                  <div className="follower-sec follower-sec-grey">
                    {ytInfluencerData?.metrics?.Audience_Retention_Rate && <FollowerCard loading={loading} title="Audience Retention Rate" iconName="" value={`${ytInfluencerData?.metrics.Audience_Retention_Rate}%`} />}
                    {ytInfluencerData?.metrics?.Avg_Video_Views_to_Subscribers && <FollowerCard thumb="positive" loading={loading} title="Avg. Video Views to Subscribers" iconName="" value={`${ytInfluencerData?.metrics.Avg_Video_Views_to_Subscribers}%`} />}
                    {ytInfluencerData?.metrics?.Avg_short_Views_to_Subscribers && <FollowerCard thumb="negative" loading={loading} title="Avg. Shorts Views to Subscribers" iconName="" value={`${ytInfluencerData?.metrics.Avg_short_Views_to_Subscribers}%`} />}
                  </div>
                </>
              }
              { (selectInflu[0]?.influencer_type == 'Orphan' && 
               selectInflu[0].email == '' && (!EngagementData && !EngagementData?.engagement?.overall?.avg_views)) && <div className="alert alert-warning">This profile is still being processed and will be fully generated shortly.</div>}

              {(genderSplit.length > 0 || columnChartData.length > 0 || minStockChartData[0]?.data.length > 0 || minStockChartData[0]?.data.length > 0) &&
                <>
                  <strong className='influencer-profile__common__title audience pb-3'>
                    Audience
                  </strong>
                  <section className="influencer-profile__common channel-insights">
                    <Grid container spacing={3}>
                      {(loading || genderSplit.length > 0) &&
                        <Grid item xs={12} sm={12} md={6} className="influencer-profile__common__inner">
                          <div className="influencer-profile__common__box">
                            <div className="inner-heading">
                              Gender
                            </div>
                            <div
                              id="paichart"
                              data-highcharts-chart={1}
                              style={{ overflow: "hidden" }}
                            >
                              {loading ? (
                                <div
                                  className="d-flex justify-content-center align-items-center"
                                  style={{
                                    height: "400px",
                                    width: "400px",
                                    margin: "0 auto",
                                  }}
                                >
                                  <Skeleton
                                    variant="circular"
                                    animation="wave"
                                    width={278}
                                    height={278}
                                  />
                                </div>
                              ) : (
                                <PieChart dataSource={genderSplit} showInLegend={false} property="percentage" title="" size="100%" height={250} marginTop={20} marginBottom={0} />
                              )
                              }
                            </div>
                            <div className="gender-value-sec gender d-flex flex-column">
                              <div className="d-flex">
                                <div className='gender-value female'>
                                  Female
                                </div>
                                <span className="ms-auto">{femaleGenderSplit === 0 ? (
                                  "NA"
                                ) : loading ? (
                                  <Skeleton width={100} />
                                ) : (
                                  `${femaleGenderSplit}%`
                                )
                                }
                                </span>
                              </div>
                              <div className="d-flex">
                                <div className='gender-value male'>
                                  Male
                                </div>
                                <span className="ms-auto">{maleGenderSplit === 0 ? (
                                  "NA"
                                ) : loading ? (
                                  <Skeleton width={100} />
                                ) : (
                                  `${maleGenderSplit}% `
                                )
                                }
                                </span>

                              </div>
                            </div>
                          </div>
                        </Grid>
                      }
                      {(loading || columnChartData.length > 0) &&
                        <Grid item xs={12} sm={12} md={6} className="influencer-profile__common__inner">
                          <div className="influencer-profile__common__box">
                            <div className="inner-heading"  >
                              Age &amp; Gender
                            </div>
                            <div
                              id="age-gender-chart"
                              className=""
                              data-highcharts-chart={0}
                              style={{ overflow: "hidden" }}
                            >
                              {loading ? (
                                <div
                                  className="d-flex justify-content-center align-items-center"
                                  style={{
                                    height: "440px",
                                    width: "400px",
                                    margin: "0 auto",
                                  }}
                                >
                                  <Skeleton
                                    variant="rectangular"
                                    animation="wave"
                                    width={440}
                                    height={400}
                                  />
                                </div>
                              ) :
                                <LineChartDropDown dataSource={columnChartData} categories={genderArrayLabel} exporting={true} legend={false} chartType='column' height="250" />
                              }
                            </div>
                            <div className="gender-value-sec">
                              <div className='gender-value female'> {loading ?
                                <Skeleton width={50} /> : "Female"}
                              </div>
                              <div className='gender-value male'> {loading ?
                                <Skeleton width={50} /> : "Male"}
                              </div>
                            </div>
                          </div>
                        </Grid>
                      }
                      <Grid item xs={12} sm={12} md={6} className="influencer-profile__common__inner">
                        {geo_view && geo_view.length > 0 &&
                          <div className="influencer-profile__common__box">
                            <div className="inner-heading"  >
                              Countries
                            </div>
                            <div className="main-content">
                              <div id="" className="examples">
                                <CityList
                                  data={geo_view}
                                  loading={loading}
                                />
                              </div>
                            </div>
                          </div>}
                      </Grid>
                      {/* <Grid item xs={12} sm={12} md={6} className="influencer-profile__common__inner">
                        <div className="influencer-profile__common__box">
                          <div className="inner-heading"  >
                            Languages
                          </div>
                          <div className="main-content">
                            <div id="" className="examples">
                              <CityList
                                data={LanguagesList}
                                loading={loading}
                              />
                            </div>
                          </div>
                        </div>

                      </Grid> */}
                    </Grid>
                  </section>
                </>}

              {(commentsData || allHashtags) &&
                <Grid container spacing={3}>
                  {commentsData && (commentsData.comment_analysis.organic.positive.percentage || commentsData.comment_analysis.paid.positive.percentage) &&
                    <Grid item xs={12} sm={12} md={6} className="influencer-profile__common__inner">
                      <div className='comment-analysis-tab-sec'>
                        <div className="influencer-profile__common__box">
                          <div className="d-flex align-items-center justify-content-between mb-3">
                            <div className="inner-heading"  >
                              Comments Analysis
                            </div>
                            <FormControl variant="standard" size="small" className="ms-auto custom-select">
                              <Select
                                value={commentFilter}
                                onChange={handleCommentFilterChange}
                                disableUnderline
                                MenuProps={{
                                  PaperProps: {
                                    className: "custom-select-dropdown", // add class to dropdown
                                  },
                                }}
                              >
                                <MenuItem value="organic">Organic</MenuItem>
                                <MenuItem value="paid">Paid</MenuItem>
                              </Select>
                            </FormControl>
                          </div>
                          <Tabs
                            activeKey={paidTabKey}
                            onSelect={(k) => setPaidTabKey(k || "positive")}
                            className="comment-analysis-tab"
                          >
                            <Tab
                              eventKey="positive"
                              title={<><img className='me-1' src={Positive} alt="" /> Positive <strong>{commentFilter === 'organic' ? commentsData.comment_analysis.organic.positive.percentage : commentsData.comment_analysis.paid.positive.percentage}%</strong></>}
                              className='comment-tab-content'
                            >
                              {renderCommentList(commentFilter === 'organic' ? commentsData.comment_analysis.organic.positive.comments : commentsData.comment_analysis.paid.positive.comments)}
                            </Tab>
                            <Tab
                              eventKey="negative"
                              title={<><img className='me-1' src={Negative} alt="" /> Negative <strong>{commentFilter === 'organic' ? commentsData.comment_analysis.organic.negative.percentage : commentsData.comment_analysis.paid.negative.percentage}%</strong></>}
                              className='comment-tab-content'
                            >
                              {renderCommentList(commentFilter === 'organic' ? commentsData.comment_analysis.organic.negative.comments : commentsData.comment_analysis.paid.negative.comments)}
                            </Tab>
                            <Tab
                              eventKey="neutral"
                              title={<><img className='me-1' src={Neutral} alt="" /> Neutral <strong>{commentFilter === 'organic' ? commentsData.comment_analysis.organic.neutral.percentage : commentsData.comment_analysis.paid.neutral.percentage}%</strong></>}
                              className='comment-tab-content'
                            >
                              {renderCommentList(commentFilter === 'organic' ? commentsData.comment_analysis.organic.neutral.comments : commentsData.comment_analysis.paid.neutral.comments)}
                            </Tab>
                          </Tabs>

                        </div>
                      </div>
                    </Grid>}

                  {allHashtags && (allHashtags && allHashtags.length > 0) &&
                    <Grid item xs={12} sm={12} md={6} className="influencer-profile__common__inner">
                      <div className='comment-analysis-tab-sec'>
                        <div className="influencer-profile__common__box">
                          <div className="d-flex align-items-center justify-content-between mb-3">
                            <div className="inner-heading"  >
                              Hashtags
                            </div>
                            <FormControl variant="standard" size="small" className="ms-auto custom-select">
                              <Select
                                value={hashtagFilter}
                                onChange={handleHashtagFilterChange}
                                disableUnderline
                                MenuProps={{
                                  PaperProps: {
                                    className: "custom-select-dropdown", // add class to dropdown
                                  },
                                }}
                              >
                                <MenuItem value={'organic'}>Organic</MenuItem>
                                <MenuItem value={'paid'}>Paid</MenuItem>
                              </Select>
                            </FormControl>
                          </div>
                          <WordCloudComponent youtube="true" words={hashtags} componentName="Organic Hashtags" />
                        </div>
                      </div>
                    </Grid>}
                </Grid>
              }
              {/* {(loading || viewStockChartData.length > 0) &&
                      <Grid item xs={12} sm={12} md={6} className="influencer-profile__common__inner">
                        <div className=" influencer-profile__common__box">
                          <span className="inner-heading">Views</span>
                          {loading ? (
                                                      <div
                                                        className="d-flex justify-content-center align-items-center"
                                                        style={{
                                                          height: "400px",
                                                          width: "440px",
                                                          margin: "0 auto",
                                                        }}
                                                      >
                                                        <Skeleton
                                                          variant="rectangular"
                                                          animation="wave"
                                                          width={440}
                                                          height={340}
                                                        />
                                                      </div>
                                                    ) : (
                          <StockChart loading={loading} dataSource={viewStockChartData} title="" />
                                                    )
                          }
                        </div>
                      </Grid>
                    }

                    {(loading || minStockChartData[0]?.data.length > 0) &&
                      <Grid item xs={12} sm={12} md={6} className="influencer-profile__common__inner">
                        <div className="influencer-profile__common__box">
                          <span className="inner-heading">Estimated Minutes Watched</span>
                          {loading ? (
                                                      <div
                                                        className="d-flex justify-content-center align-items-center"
                                                        style={{
                                                          height: "400px",
                                                          width: "440px",
                                                          margin: "0 auto",
                                                        }}
                                                      >
                                                        <Skeleton
                                                          variant="rectangular"
                                                          animation="wave"
                                                          width={440}
                                                          height={340}
                                                        />
                                                      </div>
                                                    ) : (
                          <StockChart dataSource={minStockChartData} title="" />
                                                    )}
                        </div>
                      </Grid>
                    } */}
              {/* </Grid> */}

              {/* </section> */}
              {EngagementData && (EngagementData.engagement.videos.avg_likes || EngagementData.engagement.shorts.avg_likes || EngagementData.engagement.paid.avg_likes || EngagementData.engagement.organic.avg_likes) &&
                <section className="d-flex flex-column w-100">
                  <div className="d-flex w-100 align-items-center pb-3 pt-3">
                    <strong className='influencer-profile__common__title audience'>
                      Engagement

                    </strong>
                      <FormControl variant="standard" size="small" className="ms-auto custom-select">
                        <Select
                                value={timeRangeEngagement}
                                onChange={handleEngagementChange}
                                disableUnderline
                                MenuProps={{
                                  PaperProps: {
                                    className: "custom-select-dropdown", // add class to dropdown
                                  },
                                }}
                              >
                        <MenuItem value={'7_days'}>Last 7 days</MenuItem>
                        <MenuItem value={'30_days'}>Last 30 days</MenuItem>
                        <MenuItem value={'3_months'}>Last 3 months</MenuItem>
                        <MenuItem disabled value={'6_months'}>
                          Last 6 months
                        </MenuItem>
                        <MenuItem disabled value={'12_months'}>
                          Last year
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                  {/* <strong className='influencer-profile__common__title audience pb-3 d-block'>
                    Engagement
                  </strong>
                  <FormControl variant="standard" size="small" className="ms-auto">
                  <Select
                    value={timeRange}
                    onChange={handleChange}
                    disableUnderline
                    sx={{
                      fontSize: '14px',
                      color: '#5f6368',
                      boxShadow: 'none',
                      '.MuiSelect-icon': {
                        color: '#5f6368', // arrow color
                      },
                      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        border: 'none',
                      },
                    }}
                  >
                    <MenuItem value={'7_days'}>Last 7 days</MenuItem>
                    <MenuItem value={'30_days'}>Last 30 days</MenuItem>
                    <MenuItem value={'3_months'}>Last 3 months</MenuItem>
                    <MenuItem disabled value={'6_months'}>Last 6 months</MenuItem>
                    <MenuItem disabled value={'12_months'}>Last year</MenuItem>
                  </Select>
                </FormControl> */}
                  {EngagementData.engagement.videos.avg_likes &&
                    <>
                      <strong className='d-block influencer-inner-heading audience fs-18'>
                        Videos
                      </strong>
                      {/* <div className="follower-sec follower-sec-grey w-100">
                        <FollowerCard loading={loading} title="Avg. Likes" iconName="" value={methods.formatInfluencerProfileNumber(EngagementData.engagement.videos.avg_likes)} />

                        <FollowerCard loading={loading} title="Avg. Comments" iconName="" value={methods.formatInfluencerProfileNumber(EngagementData.engagement.videos.avg_comments)} />

                        <FollowerCard thumb="negative" loading={loading} title="Frequency (per week)" iconName="" value={EngagementData.engagement.videos.frequency_per_week} />
                      </div>
                      <div className="follower-sec follower-sec-grey">
                        <div className="row">
                          <div className="col-6">
                            <FollowerCard variant="semi-circle-variant" handlePointClick={handlePointClick} browserData={browserData} loading={loading} title="Avg. Views" iconName="" value={methods.formatInfluencerProfileNumber(EngagementData.engagement.videos.avg_views)} SemiCircleHeight={75} SemiCircleWidth={150} thumbPosition="down" thumbData="20.13% lower than the average channel views" avatarPercentage={60} avatarUrl={DefaultUserProfile.influencer_male_default} data={[
                              { label: 'Chrome', value: 20, color: '#3AB4B4' },
                              { label: 'Edge', value: 20, color: '#72DCC1' },
                              { label: 'Firefox', value: 20, color: '#BDCE3B' },
                              { label: 'Safari', value: 20, color: '#E9D437' },
                              { label: 'IE', value: 20, color: '#608FDA' },
                            ]}
                            />

                          </div>
                          <div className="col-6">
                            <FollowerCard variant="semi-circle-variant" handlePointClick={handlePointClick} browserData={browserData} loading={loading} title="Engagement Rate" iconName="" value={`${EngagementData.engagement.videos.engagement_rate}%`} SemiCircleHeight={75} SemiCircleWidth={150} thumbPosition="up" thumbData="Similar to 50% of other Influencers in this category" avatarPercentage={40} avatarUrl={DefaultUserProfile.influencer_male_default} data={[
                              { label: 'Chrome', value: 20, color: '#3AB4B4' },
                              { label: 'Edge', value: 20, color: '#72DCC1' },
                              { label: 'Firefox', value: 20, color: '#BDCE3B' },
                              { label: 'Safari', value: 20, color: '#E9D437' },
                              { label: 'IE', value: 20, color: '#608FDA' },
                            ]}
                            />

                          </div>
                        </div>
                      </div> */}
                      <div className="follower-sec follower-sec-grey w-100 follower-sec-6-3-3">
                        <FollowerCard variant="half-half" loading={loading} title="Avg. Likes" iconName="" value={methods.formatInfluencerProfileNumber(EngagementData.engagement.videos.avg_likes)} />

                        <div className="follower-sec-3-3">
                          <FollowerCard className="col-md-6" loading={loading} title="Avg. Comments" iconName="" value={methods.formatInfluencerProfileNumber(EngagementData.engagement.videos.avg_comments)} />

                          <FollowerCard loading={loading} title="Frequency (per week)" iconName="" value={EngagementData.engagement.videos.frequency_per_week} />
                        </div>

                        <FollowerCard variant="half-half" loading={loading} title="Avg. Views" iconName="" value={methods.formatInfluencerProfileNumber(EngagementData.engagement.videos.avg_views)} thumbPosition={
                          EngagementData.engagement.videos.compare.includes('higher')
                            ? 'up'
                            : EngagementData.engagement.videos.compare.includes('lower')
                            ? 'down'
                            : ''
                        }
                        thumbData={
                          EngagementData.engagement.videos.compare.includes('higher') || EngagementData.engagement.videos.compare.includes('lower')
                            ? EngagementData.engagement.videos.compare
                            : ''
                        }/>


                        <FollowerCard loading={loading} title="Engagement Rate" iconName="" value={`${EngagementData.engagement.videos.engagement_rate}%`} />


                      </div>
                    </>}
                  {EngagementData.engagement.shorts.avg_likes &&
                    <>
                      <strong className='d-block influencer-inner-heading audience fs-18'>
                        Shorts
                      </strong>
                      {/* <div className="follower-sec follower-sec-grey w-100"> */}

                      <div className="follower-sec follower-sec-grey w-100 follower-sec-6-3-3">

                        <FollowerCard variant="half-half" loading={loading} title="Avg. Likes" iconName="" value={methods.formatInfluencerProfileNumber(EngagementData.engagement.shorts.avg_likes)} />

                        <div className="follower-sec-3-3">

                          <FollowerCard className="col-md-6" loading={loading} title="Avg. Comments" iconName="" value={methods.formatInfluencerProfileNumber(EngagementData.engagement.shorts.avg_comments)} />

                          <FollowerCard loading={loading} title="Frequency (per week)" iconName="" value={EngagementData.engagement.shorts.frequency_per_week} />
                        </div>
                        <FollowerCard variant="half-half" loading={loading} title="Avg. Views" iconName="" value={methods.formatInfluencerProfileNumber(EngagementData.engagement.shorts.avg_views)} 
                        thumbPosition={EngagementData.engagement.shorts.compare.includes('higher')
                            ? 'up'
                            : EngagementData.engagement.shorts.compare.includes('lower')
                            ? 'down'
                            : ''
                        }
                        thumbData={
                          EngagementData.engagement.shorts.compare.includes('higher') || EngagementData.engagement.shorts.compare.includes('lower')
                            ? EngagementData.engagement.shorts.compare
                            : ''
                        }/>

                        <FollowerCard loading={loading} title="Engagement Rate" iconName="" value={`${EngagementData.engagement.shorts.engagement_rate}%`} />
                      </div>
                      {/* <div className="follower-sec follower-sec-grey">
                        <div className="row">
                          <div className="col-6">
                            <FollowerCard variant="semi-circle-variant" handlePointClick={handlePointClick} browserData={browserData} loading={loading} title="Avg. Views" iconName="" value={methods.formatInfluencerProfileNumber(EngagementData.engagement.shorts.avg_views)} SemiCircleHeight={75} SemiCircleWidth={150} thumbPosition="down" thumbData="20.13% lower than the average channel views" avatarPercentage={60} avatarUrl={DefaultUserProfile.influencer_male_default} data={[
                              { label: 'Chrome', value: 20, color: '#3AB4B4' },
                              { label: 'Edge', value: 20, color: '#72DCC1' },
                              { label: 'Firefox', value: 20, color: '#BDCE3B' },
                              { label: 'Safari', value: 20, color: '#E9D437' },
                              { label: 'IE', value: 20, color: '#608FDA' },
                            ]}
                            />

                          </div>
                          <div className="col-6">
                            <FollowerCard variant="semi-circle-variant" handlePointClick={handlePointClick} browserData={browserData} loading={loading} title="Engagement Rate" iconName="" value={`${EngagementData.engagement.shorts.engagement_rate}%`} SemiCircleHeight={75} SemiCircleWidth={150} thumbPosition="up" thumbData="Similar to 50% of other Influencers in this category" avatarPercentage={40} avatarUrl={DefaultUserProfile.influencer_male_default} data={[
                              { label: 'Chrome', value: 20, color: '#3AB4B4' },
                              { label: 'Edge', value: 20, color: '#72DCC1' },
                              { label: 'Firefox', value: 20, color: '#BDCE3B' },
                              { label: 'Safari', value: 20, color: '#E9D437' },
                              { label: 'IE', value: 20, color: '#608FDA' },
                            ]}
                            />

                          </div>
                        </div>
                      </div> */}
                    </>}
                  {EngagementData.engagement.paid.avg_likes &&
                    <>
                      <strong className='d-block influencer-inner-heading audience fs-18'>
                        Paid Content
                      </strong>
                      <div className="follower-sec follower-sec-grey w-100 follower-sec-6-3-3">
                        <FollowerCard variant="half-half" loading={loading} title="Avg. Views" iconName="" value={methods.formatInfluencerProfileNumber(EngagementData.engagement.paid.avg_views)} 
                         thumbPosition={EngagementData.engagement.paid.compare.includes('higher')
                            ? 'up'
                            : EngagementData.engagement.paid.compare.includes('lower')
                            ? 'down'
                            : ''
                        }
                        thumbData={
                          EngagementData.engagement.paid.compare.includes('higher') || EngagementData.engagement.paid.compare.includes('lower')
                            ? EngagementData.engagement.paid.compare
                            : ''
                        }/>
                        <div className="follower-sec-3-3">
                          <FollowerCard className="col-md-6" loading={loading} title="Avg. Likes" value={methods.formatInfluencerProfileNumber(EngagementData.engagement.paid.avg_likes)} />
                          <FollowerCard loading={loading} className="col-md-6" title="Avg. Comments" value={methods.formatInfluencerProfileNumber(EngagementData.engagement.paid.avg_comments)} />
                        </div>
                        <FollowerCard variant="half-half" loading={loading} title="Engagement Rate" iconName="" value={`${EngagementData.engagement.paid.engagement_rate}%`} />
                        <FollowerCard loading={loading} title="Frequency (per week)" iconName="" value={EngagementData.engagement.paid.frequency_per_week} />
                      </div>
                    </>}






                  {EngagementData.engagement.organic.avg_likes &&
                    <>
                      <strong className='d-block influencer-inner-heading audience fs-18'>
                        Organic Content
                      </strong>

                      <div className="follower-sec follower-sec-grey w-100 follower-sec-6-3-3">


                        <FollowerCard variant="half-half" loading={loading} title="Avg. Views" iconName="" value={methods.formatInfluencerProfileNumber(EngagementData.engagement.organic.avg_views)} 
                         thumbPosition={EngagementData.engagement.organic.compare.includes('higher')
                            ? 'up'
                            : EngagementData.engagement.organic.compare.includes('lower')
                            ? 'down'
                            : ''
                        }
                        thumbData={
                          EngagementData.engagement.organic.compare.includes('higher') || EngagementData.engagement.organic.compare.includes('lower')
                            ? EngagementData.engagement.organic.compare
                            : ''
                        }/>
                        <div className="follower-sec-3-3">
                          <FollowerCard className="col-md-6" loading={loading} title="Avg. Likes" value={methods.formatInfluencerProfileNumber(EngagementData.engagement.organic.avg_likes)} />
                          <FollowerCard loading={loading} className="col-md-6" title="Avg. Comments" value={methods.formatInfluencerProfileNumber(EngagementData.engagement.organic.avg_comments)} />
                        </div>
                        <FollowerCard variant="half-half" loading={loading} title="Engagement Rate" iconName="" value={`${EngagementData.engagement.organic.engagement_rate}%`} />
                        <FollowerCard loading={loading} title="Frequency (per week)" iconName="" value={EngagementData.engagement.organic.frequency_per_week} />
                      </div></>}
                </section>}

              {EngagementData && EngagementData.engagement.overall.avg_views &&
                <section className="d-flex flex-column w-100">
                  <strong className='influencer-profile__common__title audience pb-3 d-block'>
                    Video Performance Summary Table
                  </strong>
                  {/* <TableContainer className="common-table mb-3">
                  <Table sx={{ minWidth: 650 }} aria-label="video performance summary table">
                    <TableHead className="common-table-header">
                      <TableRow className="yt_profile_table_row">
                        <TableCell sx={{ py: 2 }}>Metric</TableCell>
                        <TableCell sx={{ py: 2 }}>Videos</TableCell>
                        <TableCell sx={{ py: 2 }}>Shorts</TableCell>
                        <TableCell sx={{ py: 2 }}>Paid Videos</TableCell>
                        <TableCell sx={{ py: 2 }}>Paid Shorts</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody className="common-table-body">
                      <TableRow className="yt_profile_table_row">
                        <TableCell>Total Avg Views</TableCell>
                        <TableCell>{EngagementData.engagement.videos.avg_views ? methods.formatInfluencerProfileNumber(EngagementData.engagement.videos.avg_views) : '-'}</TableCell>
                        <TableCell>{EngagementData.engagement.shorts.avg_views ? methods.formatInfluencerProfileNumber(EngagementData.engagement.shorts.avg_views) : '-'}</TableCell>
                        <TableCell>{EngagementData.engagement.paid_video.avg_views ? methods.formatInfluencerProfileNumber(EngagementData.engagement.paid_video.avg_views) : '-'}</TableCell>
                        <TableCell>{EngagementData.engagement.paid_short.avg_views ? methods.formatInfluencerProfileNumber(EngagementData.engagement.paid_short.avg_views) : '-'}</TableCell>
                      </TableRow>

                      <TableRow className="yt_profile_table_row">
                        <TableCell>Avg Comments</TableCell>
                        <TableCell>{EngagementData.engagement.videos.avg_comments ? methods.formatInfluencerProfileNumber(EngagementData.engagement.videos.avg_comments) : '-'}</TableCell>
                        <TableCell>{EngagementData.engagement.shorts.avg_comments ? methods.formatInfluencerProfileNumber(EngagementData.engagement.shorts.avg_comments) : '-'}</TableCell>
                        <TableCell>{EngagementData.engagement.paid_video.avg_comments ? methods.formatInfluencerProfileNumber(EngagementData.engagement.paid_video.avg_comments) : '-'}</TableCell>
                        <TableCell>{EngagementData.engagement.paid_short.avg_comments ? methods.formatInfluencerProfileNumber(EngagementData.engagement.paid_short.avg_comments) : '-'}</TableCell>
                      </TableRow>

                      <TableRow className="yt_profile_table_row">
                        <TableCell>Avg Likes</TableCell>
                        <TableCell>{EngagementData.engagement.videos.avg_likes ? methods.formatInfluencerProfileNumber(EngagementData.engagement.videos.avg_likes) : '-'}</TableCell>
                        <TableCell>{EngagementData.engagement.shorts.avg_likes ? methods.formatInfluencerProfileNumber(EngagementData.engagement.shorts.avg_likes) : '-'}</TableCell>
                        <TableCell>{EngagementData.engagement.paid_video.avg_likes ? methods.formatInfluencerProfileNumber(EngagementData.engagement.paid_video.avg_likes) : '-'}</TableCell>
                        <TableCell>{EngagementData.engagement.paid_short.avg_likes ? methods.formatInfluencerProfileNumber(EngagementData.engagement.paid_short.avg_likes) : '-'}</TableCell>
                      </TableRow>

                      <TableRow className="yt_profile_table_row">
                        <TableCell>Engagement Rate (%)</TableCell>
                        <TableCell>{EngagementData.engagement.videos.engagement_rate != null ? `${EngagementData.engagement.videos.engagement_rate}%` : '-'}</TableCell>
                        <TableCell>{EngagementData.engagement.shorts.engagement_rate != null ? `${EngagementData.engagement.shorts.engagement_rate}%` : '-'}</TableCell>
                        <TableCell>{EngagementData.engagement.paid_video.engagement_rate != null ? `${EngagementData.engagement.paid_video.engagement_rate}%` : '-'}</TableCell>
                        <TableCell>{EngagementData.engagement.paid_short.engagement_rate != null ? `${EngagementData.engagement.paid_short.engagement_rate}%` : '-'}</TableCell>
                      </TableRow>

                      <TableRow className="yt_profile_table_row">
                        <TableCell>Posting Frequency</TableCell>
                        <TableCell>{EngagementData.engagement.videos.frequency_per_week ?? '-'}</TableCell>
                        <TableCell>{EngagementData.engagement.shorts.frequency_per_week ?? '-'}</TableCell>
                        <TableCell>{EngagementData.engagement.paid_video.frequency_per_week ?? '-'}</TableCell>
                        <TableCell>{EngagementData.engagement.paid_short.frequency_per_week ?? '-'}</TableCell>
                      </TableRow>
                    </TableBody>

                  </Table>
                </TableContainer> */}


                  <TableContainer className="common-table mb-3">
                    <Table sx={{ minWidth: 650 }} aria-label="video performance summary table">
                      <TableHead className="common-table-header">
                        <TableRow className="yt_profile_table_row">
                          <TableCell sx={{ py: 2 }}>Metric</TableCell>
                          <TableCell sx={{ py: 2 }}>Videos</TableCell>
                          <TableCell sx={{ py: 2 }}>Shorts</TableCell>
                          <TableCell sx={{ py: 2 }}>Paid Videos</TableCell>
                          <TableCell sx={{ py: 2 }}>Paid Shorts</TableCell>
                        </TableRow>
                      </TableHead>

                      <TableBody
                        className="common-table-body"
                        sx={{
                          '& .MuiTableCell-root': { py: 2 }, // add padding to all rows
                        }}
                      >
                        <TableRow className="yt_profile_table_row">
                          <TableCell>
                            <VisibilityIcon sx={{ fontSize: 16, mr: 1, verticalAlign: 'middle' }} />
                            Avg Views
                          </TableCell>
                          <TableCell>{EngagementData.engagement.videos.avg_views ? methods.formatInfluencerProfileNumber(EngagementData.engagement.videos.avg_views) : '-'}</TableCell>
                          <TableCell>{EngagementData.engagement.shorts.avg_views ? methods.formatInfluencerProfileNumber(EngagementData.engagement.shorts.avg_views) : '-'}</TableCell>
                          <TableCell>{EngagementData.engagement.paid_video.avg_views ? methods.formatInfluencerProfileNumber(EngagementData.engagement.paid_video.avg_views) : '-'}</TableCell>
                          <TableCell>{EngagementData.engagement.paid_short.avg_views ? methods.formatInfluencerProfileNumber(EngagementData.engagement.paid_short.avg_views) : '-'}</TableCell>
                        </TableRow>

                        <TableRow className="yt_profile_table_row">
                          <TableCell>
                            <CommentIcon sx={{ fontSize: 16, mr: 1, verticalAlign: 'middle' }} />
                            Avg Comments
                          </TableCell>
                          <TableCell>{EngagementData.engagement.videos.avg_comments ? methods.formatInfluencerProfileNumber(EngagementData.engagement.videos.avg_comments) : '-'}</TableCell>
                          <TableCell>{EngagementData.engagement.shorts.avg_comments ? methods.formatInfluencerProfileNumber(EngagementData.engagement.shorts.avg_comments) : '-'}</TableCell>
                          <TableCell>{EngagementData.engagement.paid_video.avg_comments ? methods.formatInfluencerProfileNumber(EngagementData.engagement.paid_video.avg_comments) : '-'}</TableCell>
                          <TableCell>{EngagementData.engagement.paid_short.avg_comments ? methods.formatInfluencerProfileNumber(EngagementData.engagement.paid_short.avg_comments) : '-'}</TableCell>
                        </TableRow>

                        <TableRow className="yt_profile_table_row">
                          <TableCell>
                            <ThumbUpIcon sx={{ fontSize: 16, mr: 1, verticalAlign: 'middle' }} />
                            Avg Likes
                          </TableCell>
                          <TableCell>{EngagementData.engagement.videos.avg_likes ? methods.formatInfluencerProfileNumber(EngagementData.engagement.videos.avg_likes) : '-'}</TableCell>
                          <TableCell>{EngagementData.engagement.shorts.avg_likes ? methods.formatInfluencerProfileNumber(EngagementData.engagement.shorts.avg_likes) : '-'}</TableCell>
                          <TableCell>{EngagementData.engagement.paid_video.avg_likes ? methods.formatInfluencerProfileNumber(EngagementData.engagement.paid_video.avg_likes) : '-'}</TableCell>
                          <TableCell>{EngagementData.engagement.paid_short.avg_likes ? methods.formatInfluencerProfileNumber(EngagementData.engagement.paid_short.avg_likes) : '-'}</TableCell>
                        </TableRow>

                        <TableRow className="yt_profile_table_row">
                          <TableCell>
                            <InsightsIcon sx={{ fontSize: 16, mr: 1, verticalAlign: 'middle' }} />
                            Engagement Rate (%)
                          </TableCell>
                          <TableCell>{EngagementData.engagement.videos.engagement_rate != null ? `${EngagementData.engagement.videos.engagement_rate}%` : '-'}</TableCell>
                          <TableCell>{EngagementData.engagement.shorts.engagement_rate != null ? `${EngagementData.engagement.shorts.engagement_rate}%` : '-'}</TableCell>
                          <TableCell>{EngagementData.engagement.paid_video.engagement_rate != null ? `${EngagementData.engagement.paid_video.engagement_rate}%` : '-'}</TableCell>
                          <TableCell>{EngagementData.engagement.paid_short.engagement_rate != null ? `${EngagementData.engagement.paid_short.engagement_rate}%` : '-'}</TableCell>
                        </TableRow>

                        <TableRow className="yt_profile_table_row">
                          <TableCell>
                            <CalendarTodayIcon sx={{ fontSize: 16, mr: 1, verticalAlign: 'middle' }} />
                            Posting Frequency
                          </TableCell>
                          <TableCell>{EngagementData.engagement.videos.frequency_per_week ?? '-'}</TableCell>
                          <TableCell>{EngagementData.engagement.shorts.frequency_per_week ?? '-'}</TableCell>
                          <TableCell>{EngagementData.engagement.paid_video.frequency_per_week ?? '-'}</TableCell>
                          <TableCell>{EngagementData.engagement.paid_short.frequency_per_week ?? '-'}</TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>



                </section>
              }


              {deviceAvgViewPieChartData.length > 0 && <>



                <section className="influencer-profile__common channel-insights mt-2">

                  <Grid container rowSpacing={0} spacing={3}>
                    <Grid item xs={12} sm={12} md={6} className="d-flex flex-column">
                      <strong className='influencer-profile__common__title audience pb-3'>
                        Avg. Views by Devices
                      </strong>
                      <div className="influencer-profile__common__inner pt-1">
                        <div className="influencer-profile__common__box">

                          <div className="main-content">

                            <DonutChart
                              // dataSource={[
                              //   { name: 'Mobile', y: , color: '#3498db' },
                              //   { name: 'Tablet', y: 24, color: '#ff69b4' },
                              //   { name: 'TV', y: 15, color: '#a569bd' },

                              // ]}
                              dataSource={deviceAvgViewPieChartData}
                              height={200}
                              innerSize="70%"
                              className="share-chart"
                            />


                          </div>
                        </div>
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} className="d-flex flex-column">
                      <strong className='influencer-profile__common__title audience pb-3'>
                        Social Share
                      </strong>
                      <div className="influencer-profile__common__inner pt-1">
                        <div className="influencer-profile__common__box">

                          <div className="main-content">

                            <DonutChart
                              dataSource={socialSharePieChartData}
                              height={200}
                              innerSize="70%"
                              className="share-chart"
                            />

                          </div>
                        </div>
                      </div>
                    </Grid>

                  </Grid>

                </section>
              </>}
              {/* <strong className='influencer-profile__common__title audience pb-3'>
                Price Range
              </strong>
              <section className="influencer-profile__common  price-range mt-2">
                <ul className="w-100">
                  <li>
                    <span>Dedicated Video</span>
                    <strong>₹80,000 - ₹1,00,000</strong>
                  </li>

                  <li>
                    <span>Integrated Video</span>
                    <strong>₹55,000 - ₹75,000</strong>
                  </li>
                  <li>
                    <span>Shorts</span>
                    <strong>₹55,000 - ₹75,000</strong>
                  </li>
                </ul>

              </section> */}
              {/* <strong className='influencer-profile__common__title audience pb-3'>
                Earned Media Value (EMV)
              </strong>
              <section className="influencer-profile__common geo-specific">
                <Grid container>

                  <Grid className="" item xs={12} sm={12} md={12}>
                    <div className="influencer-profile__common__box">
                      {loading ? (
                        <div
                          className="d-flex justify-content-center align-items-center"
                          style={{
                            height: "400px",
                            width: "220px",
                            margin: "0 auto",
                          }}
                        >
                          <Skeleton
                            variant="circular"
                            animation="wave"
                            width={220}
                            height={220}
                          />
                        </div>
                      ) : (
                        <StockChart dataSource={deviceViewStockChartData} title="" />
                      )}
                    </div>
                  </Grid>

                </Grid>
              </section> */}

              {/* brand engaged section commented out as per request */}
              {/* <section className="influencer-profile__common geo-specific">
                <div style={{ width: '100%' }}>
                  <div className="d-flex flex-column">
                    <div className="d-flex">
                      <strong className='influencer-profile__common__title audience pb-3 me-3'>
                        Brands Engaged
                      </strong>
                      <div style={{}}>
                        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 16 }}>
                          {BrandcategoryTab.map((cat) => (
                            <button
                              key={cat}
                              onClick={() => setBrandSelectedCategory(cat)}
                              style={{
                                padding: '6px 12px',
                                borderRadius: 20,
                                border: '1px solid #ccc',
                                background: brandSelectedCategory === cat ? '#000' : '#fff',
                                color: brandSelectedCategory === cat ? '#fff' : '#000',
                                cursor: 'pointer',
                                fontSize: 14,
                              }}
                            >
                              {cat}
                            </button>
                          ))}
                        </div>
                      </div>
                    </div>
                    <div style={{ maxWidth: '100%', overflow: 'hidden', padding: 20, background: '#fff', borderRadius: 8, border: '1px solid #5d5d5d', }}>
                      <Slider {...sliderSettings}>
                        {BrandsFilteredData.map((brand, index) => (
                          <div
                            key={index}

                          >
                            <div className="brand-box">
                              <div className="brand-box-img">
                                <img
                                  src={brand.img}
                                  alt={brand.name}
                                  className="brand-box-inner-img"
                                />
                              </div>
                              <span className="brand-box-name">{brand?.name}</span>
                              <span className="brand-box-post-count">{brand?.posts} Posts</span>
                            </div>
                          </div>
                        ))}
                      </Slider>
                    </div>
                  </div>
                </div>

              </section> */}

              {(props?.UserReducer?.account_type === 'Brand' || props?.UserReducer?.account_type === 'Agency' || shareMode) && similar_profiles && similar_profiles.length > 0 &&
                <section className="influencer-profile__common geo-specific">
                  <div style={{ width: '100%' }}>
                    <div className="d-flex flex-column">
                      <div className="d-flex">
                        <strong className='influencer-profile__common__title audience pb-3 me-3'>
                          Similar Profiles
                        </strong>
                        <div style={{}}>

                        </div>
                      </div>
                      <div style={{ maxWidth: '100%', overflow: 'hidden', padding: 12, background: '#fff', borderRadius: 8, border: '1px solid #5d5d5d', }}>
                        <Slider {...sliderSettings}>
                          {similar_profiles.map((influencer: any, index: number) => (
                            <div
                              key={index}

                            >
                              <div className="brand-box" onClick={() => handleSimilarProfileClick(influencer)}>
                                <div className="brand-box-img">
                                  <Tooltip title={influencer.name}>
                                    <img
                                      src={
                                        influencer.profile_image_url ||
                                        influencer.gcp_profile_image_url ||
                                        DefaultUserProfile.influencer_unknown_default
                                      }
                                      alt={influencer.name}
                                      className="brand-box-inner-img"
                                    />
                                  </Tooltip>
                                </div>

                                <Tooltip title={influencer.name}>
                                  <span className="brand-box-name">{influencer.name}</span>
                                </Tooltip>

                                <Tooltip title={influencer.title}>
                                  <span className="brand-box-post-count username">{influencer.title}</span>
                                </Tooltip>

                                <Tooltip title={`${methods.convertNumber(parseInt(influencer.subscriber_count))} subscribers`}>
                                  <span className="brand-box-name">{methods.convertNumber(parseInt(influencer.subscriber_count))}</span>
                                </Tooltip>
                              </div>
                            </div>
                          ))}
                        </Slider>
                      </div>
                    </div>
                  </div>

                </section>
              }

              {EngagementData && 
                <>
                  <div className="d-flex w-100 align-items-center pb-3">
                    <strong className='influencer-profile__common__title audience'>
                      Posts
                    </strong>
                    <FormControl variant="standard" size="small" className="ms-auto custom-select">
                        <Select
                                value={timeRangePost}
                                onChange={handlePostChange}
                                disableUnderline
                                MenuProps={{
                                  PaperProps: {
                                    className: "custom-select-dropdown", // add class to dropdown
                                  },
                                }}
                              >
                        <MenuItem value={'7_days'}>Last 7 days</MenuItem>
                        <MenuItem value={'30_days'}>Last 30 days</MenuItem>
                        <MenuItem value={'3_months'}>Last 3 months</MenuItem>
                        <MenuItem disabled value={'6_months'}>
                          Last 6 months
                        </MenuItem>
                        <MenuItem disabled value={'12_months'}>
                          Last year
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </div>

                  <VideoSection
                    title="Videos"
                    data={videoPostData}
                    ytShorts={false}
                    fetchData={(tab, page) => fetchYtPosts('videos', tab, page)}
                    resetTrigger={timeRangePost}
                  />

                  <VideoSection
                    title="Shorts"
                    data={shortPostData}
                    ytShorts={true}
                    fetchData={(tab, page) => fetchYtPosts('shorts', tab, page)}
                    resetTrigger={timeRangePost}
                  />
                </>
              }

              {/* MOST VIEWED VIDEOS */}
              {/* {(loading || ytInfluencerData?.most_viewed_videos?.length > 0) &&
                <section className="sec-media-posts yt-most-viewed-video">
                  <div className="container custom-container">
                    <strong className="sec-media-posts__title">Most Viewed Videos</strong>
                    <YTMostViewedVideos data={ytInfluencerData.most_viewed_videos} loading={loading} />
                    {ytInfluencerData && ytInfluencerData?.most_viewed_videos?.length === 0 && (
                      <div className="col-12 mt-3">
                        Not Available
                      </div>
                    )}
                  </div>
                </section>
              } */}
            </div>
          </div>

        </div>
      )}
      {socialRestrictionPopup.youtube &&
        <SocialConnectRestriction open={socialRestrictionPopup.youtube} data={yt_data} onClose={handleCloseSocialPopup_YT} continueConnect={handleContinueConnect_YT} />
      }

      {/* SHARE PROFILE Popup */}
      {openSharePopup && (
        <CommonPopUp
          className="modal-medium share-container"
          openModal={openSharePopup}
          modalTitle="Share"
          onClose={handleCloseSharePopup}
        >
          <div className="analytic-share-option d-flex align-items-center mb-3">
            <strong className="analytic-share-option-title">Share via:</strong>
            <div className="analytic-share-option-container">
              <span className="btn btn-outline-primary d-inline-flex react-share-btn">
                <WhatsappShareButton
                  url={shareURL || ""}
                  className="Demo__some-network__share-button"
                  disabled={!shareURL}
                >
                  <WhatsappIcon style={{ color: "#25D366" }} />
                  <span className="share-titles">WhatsApp</span>
                </WhatsappShareButton>
              </span>
              <button
                onClick={handleCopyShareLink}
                disabled={shareLoading}
                className="btn btn-outline-primary d-inline-flex"
              >
                <MaterialSymbol iconName="link" fontweight="200" />
                Copy Link
              </button>
            </div>
          </div>
        </CommonPopUp>
      )}

      {/* REFRESH PROFILE Popup */}
      {showRefreshPopup && (
        <CommonPopUp
          className="modal-small refresh-profile-popup"
          openModal={showRefreshPopup}
          modalTitle="Refresh Profile"
          onClose={handleCloseRefreshPopup}
          centered
        >
          <div className="popup-content text-center">
            <p className="mb-3">{refreshPopupMessage}</p>
            <button className="btn btn-primary" onClick={handleCloseRefreshPopup}>
              Okay
            </button>
          </div>
        </CommonPopUp>
      )}
    </>
  );
};

const mapStateToProps = (state: any) => {
  return {
    UserReducer: state.UserReducer.UserData,
    getSubscriptionDetail: state.Subscription.subscription_detail
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    loading: (data: any) => dispatch(Loading(data)),
    updateUser: (data: any) => dispatch(UserLogin(data)),
  };
};

const connectToRedux = connect(mapStateToProps, mapDispatchToProps)(YoutubeProfileInsight);

export { connectToRedux as YoutubeProfileInsight };